<template>
<div></div>
</template>

<script>
export default {
name: "ImageCell"
}
</script>

<style scoped>

</style>